import { useNavigate } from 'react-router-dom';
import type { ChargeDetail } from '../../../services/billing';
import { fmtPoDate } from './poFormat';

export function ChargePurchaseOrders({ charge }: { charge: ChargeDetail }) {
    // Same behaviour as the invoice rows above: a real route change, so browser
    // back returns here and forward re-opens the purchase order.
    const navigate = useNavigate();

    if (charge.purchaseOrders.length === 0) {
        return <p className="text-sm text-gray-400">No purchase orders.</p>;
    }

    return (
        <div className="border border-gray-200 rounded-lg divide-y divide-gray-100">
            {charge.purchaseOrders.map((po) => (
                <button
                    key={po.id}
                    type="button"
                    onClick={() => navigate(`/billing/purchase-orders/${po.id}`)}
                    className="w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors"
                >
                    <div className="flex items-center gap-3">
                        <span className="font-mono text-[12px] text-gray-800">{po.poNumber}</span>
                        <span className="text-sm text-gray-600 min-w-0 truncate">
                            {po.vendorName}
                        </span>
                        <span className="text-xs text-gray-400 ml-auto shrink-0">
                            Sent {fmtPoDate(po.sentAt)}
                        </span>
                    </div>
                    {/* Recipients live labelled in the PO's own Dispatch details -
                        nesting pills in a row button buries interactive tooltips. */}
                    {po.sentTo.length > 0 && (
                        <p className="mt-1.5 text-[11px] text-gray-400 truncate">
                            Sent to {po.sentTo.join(', ')}
                        </p>
                    )}
                </button>
            ))}
        </div>
    );
}
